import { render, staticRenderFns } from "./PartiesTable.vue?vue&type=template&id=c7e98186&scoped=true"
import script from "./PartiesTable.vue?vue&type=script&lang=ts"
export * from "./PartiesTable.vue?vue&type=script&lang=ts"
import style0 from "./PartiesTable.vue?vue&type=style&index=0&id=c7e98186&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e98186",
  null
  
)

export default component.exports